import React, { useEffect, useState } from "react";

/**
 * Wc2026Logo — theme-aware FIFA World Cup 2026 logomark.
 *
 * Two source PNGs in /public/wc/:
 *   • wc2026-dark.png  — gold trophy + white "26" backdrop, for dark bg
 *   • wc2026-light.png — gold trophy on white + "FIFA" text, for light bg
 *
 * Variant:
 *   • "auto"  — reads `documentElement.classList.contains('dark')`
 *               which ThemeProvider keeps in sync. Avoids the
 *               rules-of-hooks issue when the provider isn't mounted.
 *   • "dark"  — force the dark-bg variant
 *   • "light" — force the light-bg variant
 */
function readTheme() {
  if (typeof document === "undefined") return "dark";
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export default function Wc2026Logo({ variant = "auto", className = "", alt = "FIFA World Cup 2026", ...rest }) {
  const [theme, setTheme] = useState(readTheme);
  useEffect(() => {
    if (typeof MutationObserver === "undefined") return undefined;
    const obs = new MutationObserver(() => setTheme(readTheme()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  const pick = variant === "auto" ? theme : variant;
  const src = pick === "light" ? "/wc/wc2026-light.png" : "/wc/wc2026-dark.png";
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`object-contain ${className}`}
      data-testid={`wc2026-logo-${pick}`}
      {...rest}
    />
  );
}
